import { NlpModel } from '@feedyou-ai/feedbot-schema'

export function getModelWithUpdatedProviders(model: NlpModel): NlpModel {
  return model.provider ? model : { ...model, provider: { type: model.type, ...model.settings } }
}
